import styles from "./styles.module.scss";

const Title = () => {
    return <div className={`text-center ${styles["title"]}`}>Why Shopini Logistics ?</div>;
};

export default Title;
